module.exports = __webpack_public_path__ + "angular-technologies.3Rpb5tHN.svg";